import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AuthRoute from 'utils/auth/authRoute';

import { TemplarRouter } from '@weezevent/templar';

import { BlackList, Domains, DomainInformation, IdentitiesList } from 'pages/emails';
import { PageError } from '../../pages/index';
import { EmailLogs } from '../../pages/emails/emailLogs/EmailLogs';

export const EmailRouter = ({ match }) => {
    const { path } = match;
    return (
        <Switch>
            <AuthRoute exact path={`${path}/blacklist`} allow={['EmailCapacity.BLACKLIST']} render={() => <BlackList />} />

            <AuthRoute
                exact
                path={`${path}/domains`}
                allow={['EmailCapacity.DOMAIN', 'EmailCapacity.DOMAIN_ADMIN']}
                render={basenameProps => {
                    const { organizationId } = basenameProps.match.params;
                    return <Domains organizationId={organizationId} />;
                }}
            />
            <AuthRoute
                exact
                path={`${path}/domains/:domainName`}
                allow={['EmailCapacity.DOMAIN', 'EmailCapacity.DOMAIN_ADMIN']}
                render={basenameProps => {
                    const { domainName } = basenameProps.match.params;
                    return <DomainInformation domainName={domainName} />;
                }}
            />
            <AuthRoute
                exact
                path={`${path}/identities`}
                allow={['EmailCapacity.IDENTITY', 'EmailCapacity.IDENTITY_ADMIN']}
                render={basenameProps => {
                    const { organizationId } = basenameProps.match.params;
                    return <IdentitiesList organizationId={organizationId} />;
                }}
            />
            <AuthRoute
                path={`${path}/templates`}
                allow={['EmailCapacity.TEMPLATE_ADMIN', 'EmailCapacity.TEMPLATE']}
                render={({ match }) => {
                    return <TemplarRouter match={match} />;
                }}
            />
            <AuthRoute
                exact
                path={`${path}/logs`}
                allow={['EmailCapacity.LOGS', 'EmailCapacity.LOGS_ADMIN']}
                render={basenameProps => {
                    const { organizationId } = basenameProps.match.params;
                    return <EmailLogs organizationId={organizationId} />;
                }}
            />
            <Route render={() => <PageError backHomeUrl={'/'} />} />
        </Switch>
    );
};
